// src/components/CartSidebar.jsx - DİNAMİK ÜCRETSİZ KARGO SİSTEMİ
import React, { useState, useEffect } from 'react';
import { X, Plus, Minus, Trash2, ShoppingBag, ArrowRight, Tag, Gift, Check, AlertCircle, Info, Truck } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { getAllCampaigns, getFreeShippingCampaign } from '../services/discountService';

export default function CartSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [freeShippingCampaign, setFreeShippingCampaign] = useState(null);
  const { items, cartCount, updateQuantity, removeFromCart, clearCart } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    const handleToggle = () => setIsOpen(prev => !prev);
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    window.addEventListener('toggleCart', handleToggle);
    window.addEventListener('openCart', handleOpen);
    window.addEventListener('closeCart', handleClose);

    return () => {
      window.removeEventListener('toggleCart', handleToggle);
      window.removeEventListener('openCart', handleOpen);
      window.removeEventListener('closeCart', handleClose);
    };
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const [campaignsResult, freeShippingResult] = await Promise.all([
          getAllCampaigns(),
          getFreeShippingCampaign(),
        ]);

        // ✅ ÜCRETSİZ KARGO OLMAYAN KAMPANYALARI FİLTRELE
        if (campaignsResult.success) {
          const discountCampaigns = campaignsResult.campaigns.filter(campaign => {
            const isFreeShipping = campaign.freeShippingThreshold && campaign.freeShippingThreshold > 0;
            return !isFreeShipping;
          });
          setCampaigns(discountCampaigns);
          console.log('🛒 Sidebar - İndirim kampanyaları:', discountCampaigns.length);
        }

        if (freeShippingResult.success && freeShippingResult.campaign) {
          setFreeShippingCampaign(freeShippingResult.campaign);
          console.log('🚚 Ücretsiz Kargo Kampanyası:', freeShippingResult.campaign);
        }
      } catch (error) {
        console.error('Fırsatlar yüklenirken hata:', error);
      }
    };

    if (isOpen) {
      fetchOffers();
      // ... rest
    }
  }, [isOpen, items]);

  const handleCheckout = () => {
    setIsOpen(false);
    navigate('/cart');
  };

  // ✅ DİNAMİK ÜCRETSİZ KARGO LİMİTİ
  const FREE_SHIPPING_THRESHOLD = freeShippingCampaign?.freeShippingThreshold || 0;
  const hasFreeShippingCampaign = freeShippingCampaign && FREE_SHIPPING_THRESHOLD > 0;

  // Ham fiyatlardan sepet toplamını hesapla
  const calculateRawCartTotal = () => {
    console.log('🧮 SEPET TOPLAMI HESAPLANIYOR...');
    return items.reduce((sum, item) => {
      const itemPrice = item.currentPrice || item.price;
      console.log(`  - ${item.name}: ${itemPrice}₺ x ${item.quantity} = ${itemPrice * item.quantity}₺`);
      return sum + (itemPrice * item.quantity);
    }, 0);
  };

  const rawCartTotal = calculateRawCartTotal();
  console.log(`💰 Toplam Sepet: ${rawCartTotal.toFixed(2)}₺`);

  // Uygun ürünlere sahip kampanyalar
  // src/components/CartSidebar.jsx - KATEGORİ EŞLEŞTİRME DÜZELTMESİ

  // src/components/CartSidebar.jsx - Aynı fonksiyonları güncelle

  const getCampaignsWithEligibleProducts = () => {
    return campaigns.filter(campaign => {
      // ✅ Ücretsiz kargo kampanyalarını atla
      if (campaign.discountType === 'free_shipping' ||
        (campaign.freeShippingThreshold && campaign.freeShippingThreshold > 0)) {
        return false;
      }

      // ✅ Tarih kontrolü
      if (campaign.endDate) {
        const isActive = new Date(campaign.endDate) > new Date();
        if (!isActive) return false;
      }

      // ✅ Ürün uygunluğu
      return items.some(item => {
        // Genel kampanya
        if (campaign.campaignType === 'general' || !campaign.targetCategory) {
          return true;
        }

        // Kategori kampanyası
        if (campaign.campaignType === 'category' && campaign.targetCategory) {
          const itemCategory = item.category?.trim().toLowerCase() || '';
          const targetCategory = campaign.targetCategory?.trim().toLowerCase() || '';

          // Tam eşleşme
          if (itemCategory === targetCategory) return true;

          // Alt kategori
          if (itemCategory.includes(targetCategory) || targetCategory.includes(itemCategory)) {
            return true;
          }

          // Ana kategori
          const itemMainCat = itemCategory.includes('>') ? itemCategory.split('>')[0].trim() : itemCategory;
          const targetMainCat = targetCategory.includes('>') ? targetCategory.split('>')[0].trim() : targetCategory;

          return itemMainCat === targetMainCat;
        }

        // Ürün kampanyası
        if (campaign.campaignType === 'product' && campaign.targetId) {
          return item.id === campaign.targetId;
        }

        return false;
      });
    });
  };

  const getEligibleItemsTotal = (campaign) => {
    return items.reduce((sum, item) => {
      let isEligible = false;

      // Genel kampanya
      if (campaign.campaignType === 'general' || !campaign.targetCategory) {
        isEligible = true;
      }
      // Kategori kampanyası
      else if (campaign.campaignType === 'category' && campaign.targetCategory) {
        const itemCategory = item.category?.trim().toLowerCase() || '';
        const targetCategory = campaign.targetCategory?.trim().toLowerCase() || '';

        if (itemCategory === targetCategory ||
          itemCategory.includes(targetCategory) ||
          targetCategory.includes(itemCategory)) {
          isEligible = true;
        } else {
          const itemMainCat = itemCategory.includes('>') ? itemCategory.split('>')[0].trim() : itemCategory;
          const targetMainCat = targetCategory.includes('>') ? targetCategory.split('>')[0].trim() : targetCategory;
          isEligible = itemMainCat === targetMainCat;
        }
      }
      // Ürün kampanyası
      else if (campaign.campaignType === 'product' && campaign.targetId) {
        isEligible = item.id === campaign.targetId;
      }

      if (isEligible) {
        const itemPrice = item.currentPrice || item.price;
        return sum + (itemPrice * item.quantity);
      }
      return sum;
    }, 0);
  };

  // Uygulanabilir kampanyalar
  const getApplicableCampaigns = () => {
    return getCampaignsWithEligibleProducts().filter(campaign => {
      if (campaign.minPurchase) {
        const eligibleTotal = getEligibleItemsTotal(campaign);
        if (eligibleTotal < campaign.minPurchase) {
          return false;
        }
      }
      return true;
    });
  };

  // Uygulanamayan ama yakın olan
  const getNearMissCampaigns = () => {
    return getCampaignsWithEligibleProducts().filter(campaign => {
      if (campaign.minPurchase) {
        const eligibleTotal = getEligibleItemsTotal(campaign);
        if (eligibleTotal < campaign.minPurchase) {
          const remaining = campaign.minPurchase - eligibleTotal;
          return remaining <= 100;
        }
      }
      return false;
    });
  };

  const applicableCampaigns = getApplicableCampaigns();
  const nearMissCampaigns = getNearMissCampaigns();

  const bestCampaign = applicableCampaigns.length > 0
    ? applicableCampaigns.reduce((max, campaign) =>
      campaign.discountPercent > (max?.discountPercent || 0) ? campaign : max
    )
    : null;

  // Kampanya indirimi
  const calculateCampaignDiscount = () => {
    if (!bestCampaign) return 0;
    const eligibleItemsTotal = getEligibleItemsTotal(bestCampaign);
    return eligibleItemsTotal * (bestCampaign.discountPercent / 100);
  };

  const campaignDiscount = calculateCampaignDiscount();
  const totalDiscount = campaignDiscount;

  // İndirimli toplam
  const cartTotalAfterDiscounts = rawCartTotal - totalDiscount;

  // ✅ ÜRÜN BAZLI KARGO ÜCRETİ HESAPLAMA
  const calculateShippingCost = () => {
    // Eğer ücretsiz kargo kampanyası varsa ve sepet toplamı limiti aşıyorsa kargo ücretsiz
    if (hasFreeShippingCampaign && cartTotalAfterDiscounts >= FREE_SHIPPING_THRESHOLD) {
      console.log(`✅ Ücretsiz kargo kazanıldı! (${FREE_SHIPPING_THRESHOLD}₺ limitini aştı)`);
      return 0;
    }

    // Her ürünün kargo ücretini topla
    const totalShipping = items.reduce((sum, item) => {
      const itemShippingFee = Number(item.shippingFee) || 0;
      console.log(`🚚 ${item.name}: shippingFee = ${item.shippingFee} (${typeof item.shippingFee}) → ${itemShippingFee}`);
      return sum + (itemShippingFee * item.quantity);
    }, 0);

    console.log(`📦 Toplam Kargo Ücreti: ${totalShipping}₺`);
    return totalShipping;
  };

  const shippingCost = calculateShippingCost();

  // Ücretsiz kargo için kalan tutar
  const remainingForFreeShipping = hasFreeShippingCampaign
    ? Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotalAfterDiscounts)
    : 0;

  // Genel toplam
  const finalTotal = cartTotalAfterDiscounts + shippingCost;

  return (
    <>
      <div
        className={`cart-overlay ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(false)}
      />

      <div className={`cart-sidebar ${isOpen ? 'active' : ''}`}>
        <div className="cart-sidebar-header">
          <div className="cart-title">
            <ShoppingBag size={24} />
            <span>Sepetim ({cartCount})</span>
          </div>
          <button className="close-btn" onClick={() => setIsOpen(false)}>
            <X size={24} />
          </button>
        </div>

        {/* ✅ ÜCRETSİZ KARGO BARI - Sadece kampanya varsa göster */}
        {cartCount > 0 && hasFreeShippingCampaign && (
          <div className="free-shipping-bar">
            {remainingForFreeShipping > 0 ? (
              <>
                <div className="shipping-info">
                  <Truck size={16} />
                  <p>
                    <strong>{freeShippingCampaign.title || 'Ücretsiz Kargo'}</strong> için{' '}
                    <strong>{remainingForFreeShipping.toFixed(2)}₺</strong> daha ekleyin!
                  </p>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.min(100, (cartTotalAfterDiscounts / FREE_SHIPPING_THRESHOLD) * 100)}%`
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="free-shipping-success">
                <Truck size={16} />
                <p>🎉 {freeShippingCampaign.title || 'Ücretsiz kargo'} kazandınız!</p>
              </div>
            )}
          </div>
        )}

        {/* Uygulanan Fırsatlar */}
        {(applicableCampaigns.length > 0) && (
          <div className="applied-offers-mini">
            <div className="offers-title">
              <Check size={16} />
              <span>Uygulanan Fırsatlar</span>
            </div>
            {bestCampaign && (
              <div className="offer-mini campaign">
                <Tag size={14} />
                <span>{bestCampaign.title}</span>
              </div>
            )}
          </div>
        )}

        {/* Yakın Fırsatlar */}
        {(nearMissCampaigns.length > 0) && (
          <div className="near-miss-offers-mini">
            <div className="offers-title warning">
              <AlertCircle size={16} />
              <span>Yakın Olduğunuz Fırsatlar</span>
            </div>
            {nearMissCampaigns.slice(0, 1).map(campaign => {
              const eligibleTotal = getEligibleItemsTotal(campaign);
              const remaining = campaign.minPurchase - eligibleTotal;
              return (
                <div key={campaign.id} className="offer-mini warning">
                  <Info size={14} />
                  <span>
                    {campaign.targetCategory && (
                      <>{campaign.targetCategory} kategorisinden </>
                    )}
                    <strong>{remaining.toFixed(2)}₺</strong> daha ekleyin,
                    <strong> %{campaign.discountPercent} indirim</strong> kazanın!
                  </span>
                </div>
              );
            })}
          </div>
        )}

        <div className="cart-items">
          {items.length === 0 ? (
            <div className="empty-cart">
              <div className="empty-icon-wrapper">
                <div className="empty-icon-bg"></div>
                <ShoppingBag size={48} strokeWidth={1.5} />
              </div>
              <h3>Sepetiniz Boş</h3>
              <p>Beğendiğiniz ürünleri sepete ekleyerek alışverişe başlayın!</p>
              <button className="start-shopping-btn" onClick={() => setIsOpen(false)}>
                <ShoppingBag size={16} />
                Alışverişe Başla
              </button>
              <div className="empty-features">
                {hasFreeShippingCampaign && (
                  <div className="empty-feature">
                    <Truck size={16} />
                    <span>{FREE_SHIPPING_THRESHOLD}₺ üzeri ücretsiz kargo</span>
                  </div>
                )}
                <div className="empty-feature">
                  <Tag size={16} />
                  <span>Özel kampanyalar</span>
                </div>
                <div className="empty-feature">
                  <Gift size={16} />
                  <span>Hediye seçenekleri</span>
                </div>
              </div>
            </div>
          ) : (
            items.map(item => {
              const itemPrice = item.currentPrice || item.price;
              const itemOriginalPrice = item.originalPrice || item.price;
              const hasItemDiscount = itemOriginalPrice > itemPrice;
              const itemShippingFee = Number(item.shippingFee) || 0;

              return (
                <div key={item.id} className="cart-item">
                  <div className="item-image">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="item-details">
                    <h4>{item.name}</h4>
                    <div className="item-price">
                      {hasItemDiscount && (
                        <span className="original-price">
                          {itemOriginalPrice.toFixed(2)}₺
                        </span>
                      )}
                      <span className="current-price">{itemPrice.toFixed(2)}₺</span>
                    </div>
                    {/* ✅ ÜRÜN KARGO ÜCRETİ BİLGİSİ */}
                    {itemShippingFee > 0 && remainingForFreeShipping > 0 && (
                      <div className="item-shipping-info">
                        <Truck size={12} />
                        <span>Kargo: {itemShippingFee.toFixed(2)}₺</span>
                      </div>
                    )}
                    <div className="quantity-controls-cart">
                      <button
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                        disabled={item.quantity <= 1}
                      >
                        <Minus size={14} />
                      </button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>
                        <Plus size={14} />
                      </button>
                    </div>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={() => removeFromCart(item.id)}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              );
            })
          )}
        </div>

        {items.length > 0 && (
          <div className="cart-sidebar-footer">
            <div className="cart-summary">
              <div className="summary-row">
                <span>Ara Toplam</span>
                <span>{rawCartTotal.toFixed(2)}₺</span>
              </div>

              {campaignDiscount > 0 && (
                <div className="summary-row discount campaign">
                  <span>
                    <Tag size={12} />
                    Kampanya
                  </span>
                  <span>-{campaignDiscount.toFixed(2)}₺</span>
                </div>
              )}

              {/* ✅ KARGO ÜCRETİ SATIRI */}
              <div className="summary-row shipping">
                <span>
                  <Truck size={12} />
                  Kargo
                </span>
                <span className={remainingForFreeShipping === 0 && hasFreeShippingCampaign ? 'free-shipping' : ''}>
                  {remainingForFreeShipping === 0 && hasFreeShippingCampaign
                    ? 'Ücretsiz'
                    : `${shippingCost.toFixed(2)}₺`}
                </span>
              </div>

              <div className="summary-row total">
                <span>Toplam</span>
                <span>{finalTotal.toFixed(2)}₺</span>
              </div>
            </div>

            {totalDiscount > 0 && (
              <div className="savings-badge">
                <Check size={14} />
                <span>{totalDiscount.toFixed(2)}₺ tasarruf!</span>
              </div>
            )}

            {remainingForFreeShipping === 0 && hasFreeShippingCampaign && (
              <div className="free-shipping-badge">
                <Truck size={14} />
                <span>{freeShippingCampaign.title || 'Ücretsiz kargo'} kazandınız! 🎉</span>
              </div>
            )}

            <button className="checkout-btn" onClick={handleCheckout}>
              Sepete Git <ArrowRight size={18} />
            </button>

            <button className="clear-cart-btn" onClick={clearCart}>
              Sepeti Temizle
            </button>
          </div>
        )}
      </div>

      <style>{`
        .cart-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s;
          z-index: 1001;
        }
        .cart-overlay.active {
          opacity: 1;
          visibility: visible;
        }
        .cart-sidebar {
          position: fixed;
          top: 0;
          right: 0;
          width: 420px;
          max-width: calc(100% - 60px);
          height: 100vh;
          height: 100dvh;
          background: #fff;
          transform: translateX(100%);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 1002;
          display: flex;
          flex-direction: column;
          box-shadow: -4px 0 24px rgba(0,0,0,0.15);
        }
        .cart-sidebar.active {
          transform: translateX(0);
        }
        .cart-sidebar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #e9ecef;
          flex-shrink: 0;
        }
        .cart-title {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 18px;
          font-weight: 700;
        }
        .close-btn {
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          border-radius: 8px;
          transition: background 0.2s;
        }
        .close-btn:hover {
          background: #f8f9fa;
        }
        .free-shipping-bar {
          padding: 16px 20px;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-bottom: 1px solid #dee2e6;
          flex-shrink: 0;
        }
        .shipping-info {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
        }
        .shipping-info svg {
          color: #E5332A;
          flex-shrink: 0;
        }
        .shipping-info p {
          font-size: 13px;
          margin: 0;
          color: #495057;
        }
        .free-shipping-success {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #06d6a0;
          font-weight: 600;
        }
        .free-shipping-success svg {
          flex-shrink: 0;
        }
        .free-shipping-success p {
          margin: 0;
          font-size: 13px;
        }
        .no-free-shipping-info {
          padding: 12px 20px;
          background: #fff9e6;
          border-bottom: 1px solid #ffe8a1;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .no-free-shipping-info svg {
          color: #f59e0b;
          flex-shrink: 0;
        }
        .no-free-shipping-info p {
          margin: 0;
          font-size: 12px;
          color: #92400e;
        }
        .progress-bar {
          height: 6px;
          background: #dee2e6;
          border-radius: 3px;
          overflow: hidden;
        }
        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #E5332A, #ff4436);
          border-radius: 3px;
          transition: width 0.3s;
        }
        .applied-offers-mini {
          padding: 12px 20px;
          background: #f0fff4;
          border-bottom: 1px solid #dcfce7;
          flex-shrink: 0;
        }
        .offers-title {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          font-weight: 600;
          color: #16a34a;
          margin-bottom: 8px;
        }
        .offers-title.warning {
          color: #f59e0b;
        }
        .offer-mini {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          padding: 4px 8px;
          border-radius: 6px;
          margin-bottom: 4px;
          line-height: 1.4;
        }
        .offer-mini:last-child {
          margin-bottom: 0;
        }
        .offer-mini.campaign {
          background: rgba(229, 51, 42, 0.1);
          color: #E5332A;
        }
        .offer-mini.warning {
          background: rgba(245, 158, 11, 0.1);
          color: #92400e;
        }
        .offer-mini.warning strong {
          color: #f59e0b;
        }
        .near-miss-offers-mini {
          padding: 12px 20px;
          background: #fffbeb;
          border-bottom: 1px solid #fef3c7;
          flex-shrink: 0;
        }
        .cart-items {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
          -webkit-overflow-scrolling: touch;
        }
        .empty-cart {
          text-align: center;
          padding: 40px 20px;
          color: #868e96;
        }
        .empty-icon-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
        }
        .empty-icon-bg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, #fff5f5, #ffe8e8);
          border-radius: 50%;
          animation: pulse-bg 3s ease-in-out infinite;
        }
        @keyframes pulse-bg {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
          50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.5; }
        }
        .empty-cart .empty-icon-wrapper svg {
          position: relative;
          z-index: 1;
          color: #E5332A;
          margin-top: 26px;
        }
        .empty-cart h3 {
          font-size: 20px;
          margin-bottom: 8px;
          color: #2B2B2B;
          font-weight: 700;
        }
        .empty-cart p {
          font-size: 14px;
          color: #868e96;
          line-height: 1.5;
          margin-bottom: 24px;
        }
        .start-shopping-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 24px;
          background: #E5332A;
          color: #fff;
          border: none;
          padding: 12px 24px;
          border-radius: 10px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 4px 12px rgba(229, 51, 42, 0.2);
        }
        .start-shopping-btn:hover {
          background: #c72a22;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(229, 51, 42, 0.3);
        }
        .start-shopping-btn:active {
          transform: translateY(0);
        }
        .empty-features {
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding-top: 24px;
          border-top: 1px solid #e9ecef;
        }
        .empty-feature {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          background: #f8f9fa;
          border-radius: 8px;
          font-size: 13px;
          color: #495057;
          transition: all 0.2s;
        }
        .empty-feature:hover {
          background: #fff5f5;
          color: #E5332A;
        }
        .empty-feature svg {
          flex-shrink: 0;
          color: #E5332A;
        }
        .cart-item {
          display: flex;
          gap: 12px;
          padding: 16px 0;
          border-bottom: 1px solid #e9ecef;
        }
        .item-image {
          width: 80px;
          height: 80px;
          border-radius: 10px;
          overflow: hidden;
          flex-shrink: 0;
          background: #fff;
        }
        .item-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .item-details {
          flex: 1;
          min-width: 0;
        }
        .item-details h4 {
          font-size: 14px;
          margin-bottom: 6px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 1.3;
        }
        .item-price {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
        }
        .original-price {
          font-size: 12px;
          color: #868e96;
          text-decoration: line-through;
        }
        .current-price {
          font-size: 16px;
          font-weight: 700;
          color: #E5332A;
        }
        .item-shipping-info {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 11px;
          color: #6c757d;
          margin-bottom: 8px;
          background: #f8f9fa;
          padding: 4px 8px;
          border-radius: 6px;
        }
        .item-shipping-info svg {
          flex-shrink: 0;
        }
        .quantity-controls-cart {
          display: inline-flex;
          align-items: center;
          gap: 0;
          border: 1px solid #e9ecef;
          border-radius: 8px;
        }
        .quantity-controls-cart button {
          width: 32px;
          height: 32px;
          border: none;
          background: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s;
        }
        .quantity-controls-cart button:hover:not(:disabled) {
          background: #f8f9fa;
        }
        .quantity-controls-cart button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .quantity-controls-cart span {
          width: 32px;
          text-align: center;
          font-weight: 600;
        }
        .remove-btn {
          background: none;
          border: none;
          color: #868e96;
          cursor: pointer;
          padding: 8px;
          transition: color 0.2s;
          flex-shrink: 0;
        }
        .remove-btn:hover {
          color: #E5332A;
        }
        .cart-sidebar-footer {
          padding: 20px;
          border-top: 1px solid #e9ecef;
          background: #fff;
          flex-shrink: 0;
        }
        .cart-summary {
          margin-bottom: 16px;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          font-size: 14px;
        }
        .summary-row span:first-child {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #495057;
        }
        .summary-row span:last-child {
          font-weight: 600;
          color: #2B2B2B;
        }
        .summary-row.discount {
          color: #06d6a0 !important;
        }
        .summary-row.discount span {
          color: #06d6a0 !important;
          font-weight: 600;
        }
        .summary-row.discount.campaign svg {
          color: #E5332A;
        }
        .summary-row.shipping span:first-child {
          color: #495057;
        }
        .summary-row.shipping .free-shipping {
          color: #06d6a0 !important;
          font-weight: 700;
        }
        .summary-row.total {
          font-size: 18px;
          font-weight: 700;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 2px solid #e9ecef;
        }
        .summary-row.total span {
          color: #2B2B2B;
        }
        .savings-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          background: linear-gradient(135deg, #dcfce7, #a7f3d0);
          color: #16a34a;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 8px;
        }
        .free-shipping-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          background: linear-gradient(135deg, #e0f2fe, #bae6fd);
          color: #0369a1;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 12px;
        }
        .checkout-btn {
          width: 100%;
          background: #E5332A;
          color: #fff;
          border: none;
          padding: 14px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.2s;
        }
        .checkout-btn:hover {
          background: #c72a22;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
        }
        .checkout-btn:active {
          transform: scale(0.98);
        }
        .clear-cart-btn {
          width: 100%;
          margin-top: 8px;
          background: none;
          border: none;
          color: #868e96;
          padding: 10px;
          font-size: 13px;
          cursor: pointer;
          transition: color 0.2s;
        }
        .clear-cart-btn:hover {
          color: #E5332A;
        }
        @media (max-width: 576px) {
          .cart-sidebar {
            width: calc(100% - 50px);
            max-width: none;
          }
          .cart-sidebar-header {
            padding: 16px;
          }
          .cart-title {
            font-size: 16px;
          }
          .free-shipping-bar {
            padding: 12px 16px;
          }
          .shipping-info p,
          .free-shipping-success p {
            font-size: 12px;
          }
          .no-free-shipping-info {
            padding: 10px 16px;
          }
          .no-free-shipping-info p {
            font-size: 11px;
          }
          .applied-offers-mini, .near-miss-offers-mini {
            padding: 10px 16px;
          }
          .cart-items {
            padding: 16px;
          }
          .empty-cart {
            padding: 30px 16px;
          }
          .empty-icon-wrapper {
            width: 80px;
            height: 80px;
          }
          .empty-icon-bg {
            width: 80px;
            height: 80px;
          }
          .empty-cart .empty-icon-wrapper svg {
            margin-top: 16px;
          }
          .empty-cart h3 {
            font-size: 18px;
          }
          .empty-cart p {
            font-size: 13px;
          }
          .start-shopping-btn {
            width: 100%;
            justify-content: center;
          }
          .item-image {
            width: 64px;
            height: 64px;
          }
          .item-details h4 {
            font-size: 13px;
          }
          .current-price {
            font-size: 14px;
          }
          .item-shipping-info {
            font-size: 10px;
          }
          .quantity-controls-cart button {
            width: 28px;
            height: 28px;
          }
          .quantity-controls-cart span {
            width: 28px;
            font-size: 13px;
          }
          .cart-sidebar-footer {
            padding: 16px;
          }
          .summary-row {
            font-size: 13px;
          }
          .summary-row.total {
            font-size: 16px;
          }
          .checkout-btn {
            padding: 12px;
            font-size: 14px;
          }
        }
        @supports (padding: env(safe-area-inset-bottom)) {
          .cart-sidebar-footer {
            padding-bottom: calc(20px + env(safe-area-inset-bottom));
          }
        }
      `}</style>
    </>
  );
}

export const openCartSidebar = () => window.dispatchEvent(new Event('openCart'));
export const closeCartSidebar = () => window.dispatchEvent(new Event('closeCart'));
export const toggleCartSidebar = () => window.dispatchEvent(new Event('toggleCart'));